let PointType = /*#__PURE__*/function (PointType) {
  PointType["DROP_OFF"] = "drop-off";
  PointType["PICK_UP"] = "pick-up";
  return PointType;
}({});

export { PointType };
//# sourceMappingURL=DropOffAllParams.js.map
